import type { AvailabilityStatus } from '../types';

interface Props {
  status: AvailabilityStatus | null;
  onChange: (status: AvailabilityStatus) => void;
  compact?: boolean;
}

const options: { value: AvailabilityStatus; label: string; shortLabel: string; activeClass: string }[] = [
  { value: 'can_drive', label: 'Can Drive', shortLabel: 'Can', activeClass: 'bg-green-500 text-white dark:bg-green-600' },
  { value: 'prefer_not', label: 'Prefer Not', shortLabel: 'Maybe', activeClass: 'bg-amber-400 text-white dark:bg-amber-500' },
  { value: 'cant_drive', label: "Can't", shortLabel: "Can't", activeClass: 'bg-red-400 text-white dark:bg-red-500' },
];

export default function AvailabilityToggle({ status, onChange, compact }: Props) {
  return (
    <div className="flex gap-1">
      {options.map(opt => (
        <button
          key={opt.value}
          onClick={(e) => { e.stopPropagation(); onChange(opt.value); }}
          className={`rounded-full font-semibold transition-all min-h-[32px] ${
            compact ? 'text-[10px] px-2 py-0.5' : 'text-xs px-2.5 py-1'
          } ${
            status === opt.value
              ? opt.activeClass
              : 'bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
          }`}
        >
          {compact ? opt.shortLabel : opt.label}
        </button>
      ))}
    </div>
  );
}
